import {combineReducers} from 'redux';
import system from './system';
import translations from './translations';
import app from './app';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = combineReducers({
    system,
    translations,
    app,
});

export default reducers;
